import React from "react";

export const HeroPrincipal = () => <div className="bookrealm-image"></div>;
export const HeroAboutUs = () => (
  <div className="bookrealm-image_AboutUs"></div>
);
export const HeroBlog = () => <div className="bookrealm-image_Blog"></div>;
export const HeroHelp = () => <div className="bookrealm-image"></div>;
export const HeroByFilter = () => (
  <div className="bookrealm-image_FilterBy"></div>
);
export const HeroBooks = () => <div className="bookrealm-image_ApiBooks"></div>;
export const HeroInformation = () => (
  <div className="bookrealm-image_Information"></div>
);
